import {
  type BaseQueryFn,
  type FetchArgs,
  type FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { type RootState } from '@store/rootReducer';
import { logout } from '@store/session/logout';

import { fetchWhitAuth } from '../store/skeletor/fetchWhitAuth';
import { initRefreshToken } from './initRefreshToken';
import { isAuthError } from './isAuthError';

const baseQueryWithReAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await fetchWhitAuth(args, api, extraOptions);
  if (isAuthError(result.error)) {
    const { getState } = api;

    const state = getState() as RootState;

    const { isRefreshing } = initRefreshToken(
      state.session,
      state.user,
      api.dispatch,
    );

    await isRefreshing;

    const retryResult = await fetchWhitAuth(args, api, extraOptions);

    if (isAuthError(retryResult.error)) {
      await api.dispatch(logout());
    }

    return retryResult;
  }

  return result;
};

export { baseQueryWithReAuth };
